import { API_URL, setHeader } from 'api';
import axios from 'axios';
import moment from 'moment';

const URL = `${API_URL}/app-util`;

export const fetchAllDepartments = params => {
  const req = setHeader(axios);
  return req.get(`${URL}/departments`, { params });
};

export const createDepartment = department => {
  const req = setHeader(axios);
  return req.post(`${URL}/departments`, department);
};

export const updateDepartment = (id, department) => {
  const req = setHeader(axios);
  return req.put(`${URL}/departments/${id}`, {
    departmentName: department.departmentName,
    description: department.description,
  });
};

export const archiveDepartment = (id, departmentStatus) => {
  const req = setHeader(axios);
  return req.put(`${URL}/departments/${id}`, {
    departmentStatus,
  });
};

export const fetchAllRoles = () => {
  const req = setHeader(axios);
  return req.get(`${URL}/roles`);
};

export const fetchAllCategories = () => {
  const req = setHeader(axios);
  return req.get(`${URL}/display-categories`);
};

export const fetchAllQuestionTypes = () => {
  const req = setHeader(axios);
  return req.get(`${URL}/question-types`);
};

export const fetchAllUserStatus = () => {
  const req = setHeader(axios);
  return req.get(`${URL}/status/user`);
};

export const fetchAllVendorStatus = () => {
  const req = setHeader(axios);
  return req.get(`${URL}/status/vendor`);
};

export const fetchAllRequestStatus = () => {
  const req = setHeader(axios);
  return req.get(`${URL}/status/request`);
};
export const uploadFile = (association, ID, files) => {
  const req = setHeader(axios);
  let formData = new FormData();
  formData.append('file', files);
  formData.set('association', association);
  formData.set('vendorRequestID', ID);
  return req.post(`${API_URL}/upload`, formData, {
    headers: {
      ContentType: 'multipart/form-data',
    },
  });
};

export const fetchUploadedFiles = vendorRequestID => {
  const params = { vendorRequestID };
  const req = setHeader(axios);
  return req.get(`${API_URL}/upload`, { params });
};

export const fetchSingleFile = (fileID, association) => {
  const params = { association };
  const req = setHeader(axios);
  return req.get(`${API_URL}/upload/${fileID}`, {
    params,
    responseType: 'blob',
  });
};

export const deleteFile = (id, association) => {
  const params = { association };
  const req = setHeader(axios);
  return req.delete(`${API_URL}/upload/${id}`, { params });
};

export const fetchAllConfigs = () => {
  const req = setHeader(axios);
  return req.get(`${URL}/config`);
};

export const updateConfigs = obj => {
  const req = setHeader(axios);
  return req.put(`${URL}/config`, {
    max_passing_score: parseInt(obj.max_passing_score),
    comparator: obj.comparator,
    expiration_time: parseInt(obj.expiration_time),
    days_until_expiration: parseInt(obj.days_until_expiration),
    contact_email: obj.contact_email,
  });
};

export const validateCaptcha = token => {
  const req = setHeader(axios);
  return req.post(`${URL}/captcha`, { recaptchaToken: token });
};

export const createDisplayCategory = (_, categoryName) => {
  const req = setHeader(axios);
  return req.post(`${URL}/display-categories`, { categoryName });
};

export const updateDisplayCategory = (id, categoryName) => {
  const req = setHeader(axios);
  return req.post(`${URL}/display-categories/${id}`, {
    categoryName,
  });
};

export const archiveDisplayCategory = id => {
  const req = setHeader(axios);
  return req.put(`${URL}/display-categories/${id}`);
};

export const createQuestionType = (_, typeName, typeDepartments, mandatory) => {
  const req = setHeader(axios);
  return req.post(`${URL}/question-types`, {
    typeName,
	typeDepartments,
    mandatory: mandatory ? true : false,
  });
};

export const updateQuestionType = (id, typeName, typeDepartments, mandatory) => {
  const req = setHeader(axios);
  return req.post(`${URL}/question-types/${id}`, {
    typeName,
	typeDepartments,
    mandatory: mandatory ? true : false,
  });
};

export const archiveQuestionType = id => {
  const req = setHeader(axios);
  return req.put(`${URL}/question-types/${id}`);
};

export const fetchAuditLog = parameters => {
	let params = {
		start: parameters.start,
		limit: parameters.limit,
	};
	if (parameters.dateRange) {
		const { dateRange } = parameters;
		const [startDate, endDate] = dateRange;
		if (startDate && endDate) {
			params.startDate = moment(startDate).format('YYYY-MM-DD');
			params.endDate = moment(endDate).format('YYYY-MM-DD');
		}
	}
	if(parameters.vendorRequestID){
		params.vendorRequestID = parameters.vendorRequestID;
	}

	const req = setHeader(axios);
	return req.get(`${URL}/audit-logs`, { params });
};

export const fetchQuestionStatus = () => {
  const req = setHeader(axios);
  return req.get(`${URL}/status/version`);
};


export const reorderQuestionTypes = question_types => {
	const req = setHeader(axios);
	const justOrderStuff = question_types.map(q => {
		return {
			questionTypeID: q.typeID,
			displayOrder: q.displayOrder
		}
	});
	return req.post(`${URL}/question-types/order`, {
		question_types: justOrderStuff
	});
};

export const reorderDisplayCategories = display_categories => {
	const req = setHeader(axios);
	const justOrderStuff = display_categories.map(q => {
		return {
			displayCategoryID: q.categoryID,
			displayOrder: q.displayOrder
		}
	});
	return req.post(`${URL}/display-categories/order`, {
		display_categories: justOrderStuff
	});
};